// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2qQI9","checkboxCol":"Table_checkboxCol__1xgdu","emailCol":"Table_emailCol__3cQ16","actionCol":"Table_actionCol__3_ksK"};